import {
  UPDATE_PRESENTATION_DETAIL,
  HANDLE_PRESENTATION_DETAIL_ERROR
} from '../constants/ActionTypes';

export function updatePresentationDetail(response) {
  return { type: UPDATE_PRESENTATION_DETAIL, response };
}

export function handleError(fail) {
  return { type: HANDLE_PRESENTATION_DETAIL_ERROR, fail };
}

export function fetchPresentation(url) {
  return (dispatch) => {
    fetch(url) // eslint-disable-line no-undef
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        dispatch(updatePresentationDetail(json));
      })
      .catch((err) => {
        dispatch(handleError(err));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/PresentationActions.js